import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private totalRequests = 0;

  constructor(
    private loadingService: LoaderService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    var useLoadingIcon = !this.isProgressUpdateRequest(request);

    this.totalRequests++;

    //JP we don't want a spinner if this is a progress request call, it gives a nasty flashing screen!
    if (useLoadingIcon) {
      this.loadingService.setLoading(true);
    }

    return next.handle(request).pipe(
      finalize(() => {
        this.totalRequests--;
        if (this.totalRequests == 0) {
          this.loadingService.setLoading(false);
        }
      })
    );
  }

  isProgressUpdateRequest(request: HttpRequest<unknown>) {
    return request.url.endsWith("getprogressstatus") ||
           request.url.includes("/charitycentral/checkversion") ||
           // Reporting screen's case-header badges, polled every minute in the background
           request.url.includes("/charitycentral/getprobatestatusbadges");
  }


}
